import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {GenericConfig} from '@signature-it/ngx-generic/config'
import { CartActions } from '@signature-it/ngx-catalogue/store/actions';
import {Store} from "@ngrx/store";
import {SharedDataService} from '@signature-it/ngx-catalogue/services';

export interface POSDialogData {
    POSLineProducts: any
}

declare let _: any;

@Component({
    selector: 'pos-line-products-modal',
    templateUrl: './pos-line-products-modal.component.html',
    styleUrls: ['./pos-line-products-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class POSLineProductsModalComponentGeneric implements OnInit {

    POSLineProducts: any = GenericConfig.POSLineProducts;

    constructor(public dialogRef: MatDialogRef<POSLineProductsModalComponentGeneric>,
                @Inject(MAT_DIALOG_DATA) public data: POSDialogData,
                protected store$: Store<any>,
                public sharedSvc: SharedDataService) {
    }

    closeModal(): void {
        this.changeSkipModalAfterAddToCart(false);
        this.dialogRef.close(true);
    }

    ngOnInit() {
        this.changeSkipModalAfterAddToCart(true);
    }

    changeSkipModalAfterAddToCart(skip) {
        const action = CartActions.skipModalAfterAddToCart(skip);
        this.store$.dispatch(action);
    }
}
